import { useEffect, useRef } from 'react'
import { useAuth } from './useAuth'

export function usePaddle() {
  const { user, profile } = useAuth()
  const paddleLoaded = useRef(false)

  useEffect(() => {
    if (paddleLoaded.current) return
    if (typeof window === 'undefined') return

    // Load Paddle.js script
    const script = document.createElement('script')
    script.src = 'https://cdn.paddle.com/paddle/v2/paddle.js'
    script.async = true
    script.onload = () => {
      if (!window.Paddle) return

      const isSandbox = import.meta.env.VITE_PADDLE_ENV === 'sandbox'

      if (isSandbox) {
        window.Paddle.Environment.set('sandbox')
      }

      window.Paddle.Initialize({
        token: import.meta.env.VITE_PADDLE_CLIENT_TOKEN,
      })

      paddleLoaded.current = true
    }

    document.head.appendChild(script)

    return () => {
      // Don't remove script on unmount — keep Paddle loaded
    }
  }, [])

  function openCheckout() {
    if (!window.Paddle) {
      console.error('Paddle not loaded yet')
      return
    }

    window.Paddle.Checkout.open({
      items: [
        {
          priceId: import.meta.env.VITE_PADDLE_PRICE_ID,
          quantity: 1,
        },
      ],
      customer: {
        email: user?.email || '',
      },
      customData: {
        user_id: user?.id || '',
      },
      settings: {
        displayMode: 'overlay',
        theme: 'light',
        locale: 'en',
        successUrl: `${window.location.origin}/settings?billing=success`,
      },
    })
  }

  return { openCheckout }
}